var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.988C18 21.5469 17.5523 22 17 22H7C6.44772 22 6 21.5469 6 20.988V12.8795L3.24254 13.5772C2.61139 13.7369 2 13.2538 2 12.5954V8.67664C2 8.1819 2.35343 7.75967 2.83563 7.67835L7.40216 6.90825C7.74644 6.85019 8.08129 7.05423 8.19166 7.38933C8.67439 8.85498 10.0297 9.84357 11.5562 9.84357H12.4438C13.9703 9.84357 15.3256 8.85498 15.8083 7.38933C15.9187 7.05423 16.2536 6.85019 16.5978 6.90825L21.1644 7.67835C21.6466 7.75967 22 8.1819 22 8.67664V12.5954C22 13.2538 21.3886 13.7369 20.7575 13.5772L18 12.8795V20.988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 4.33333C11.15 3.90309 11.5105 3.51807 12 3.51807C12.4895 3.51807 12.85 3.90309 12.85 4.33333C12.85 4.69784 12.5943 5.02743 12.2158 5.12225C11.8942 5.20279 11.5009 5.4489 11.3327 5.86486L9.70798 7.14378C9.93591 7.6293 10.3392 8.00031 10.8241 8.18843L12 7.2628L13.1759 8.18843C13.6608 8.00031 14.0641 7.6293 14.292 7.14378L13.2397 6.31544C13.9008 5.9069 14.35 5.1787 14.35 4.33333C14.35 3.02465 13.2778 2 12 2C10.7222 2 9.65002 3.02465 9.65002 4.33333C9.65002 4.75254 9.98581 5.09237 10.4 5.09237C10.8142 5.09237 11.15 4.75254 11.15 4.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt3);
export default __webpack_public_path__ + "static/media/shirt-3.28dec3dc23329f45077d0fb4f75a4af1.svg";
export { ForwardRef as ReactComponent };